<template>
  <EditItem
    :show="show"
    :item="item"
    :detail-status-options="detailStatusOptions"
    @update:show="$emit('update:show', $event)"
    @updateItem="updateItem" />
</template>
<script>
import EditItem from './_components/EditItem.vue';

export default {
  name: 'EditItemModule',
  components: { EditItem },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      detailStatusOptions: ['pending', 'received', 'backordered', 'short'],
    };
  },
  methods: {
    async updateItem(data) {
      this.$emit('updateItem', data);
      this.$emit('update:show', false);
    },
  },
};
</script>
